<template>
<div class="chapter">
<div class="inner_page">
<p class="block_10" id="calibre_pb_9"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_11" id="id_Hlk82619698">Part 1</p>
<p class="block_11" id="id_Toc106115855">The Red Sweatshirt</p>
<p class="block_"> </p>
<p class="block_18">Bloodson Bay Police Department</p>
<p class="block_18">Police Report</p>
<p class="block_"> </p>
<p class="block_19">Location: Bloodson Bay Beach, 6th Block</p>
<p class="block_19">Date: June 27, 1986</p>
<p class="block_19">Lead Officer Name: Officer Martina Carillo</p>
<p class="block_19">Case Status: Open</p>
<p class="block_19">Incident Type: Child Disappearance</p>
<p class="block_19">Narrative:</p>
<p class="block_20"> </p>
<p class="block_19">At 9:24 p.m. on Friday, June 27, 1986, I was dispatched to the 6th Block of Bloodson Bay Beach regarding a missing child. The mother, Ginger Mallowan, reported that her 16-month-old son, Cole Mallowan, went missing from the beach for approximately 10 minutes before she called 911 from her home phone at 64 Beachside Drive. Upon arrival, I observed Miss Mallowan in a frantic state, along with her 4-year-old son Benson Mallowan. </p>
<p class="block_20"> </p>
<p class="block_19">Miss Mallowan claimed to see a white male with black hair, approximately 5-foot-9-<span class="calibre4">inches, walking along the beach 15 minutes prior to the incident. There was no sign of this unidentified male upon my arrival. No other witnesses were on the beach at the time. Miss Mallowan had taken pictures with a disposable camera minutes before the disappearance, which she provided to investigators. The photographs may contain evidence of individuals or witnesses around the area at the time of the disappearance and will be developed immediately and reviewed.  </span></p>
<p class="block_20"> </p>
<p class="block_19">The missing boy was last seen wearing a He-Man T-shirt, gray sweatpants, and red Bloodson Bay sweatshirt. Additional officers and a search-and-rescue team were called in to perform an initial sweep of the beach. A red sweatshirt matching the description was recovered in the surf by the mother. </p>
<p class="block_20"> </p>
<p class="block_19"><span class="calibre4">Child presumed dead from drowning.  </span></p>
<p class="block_6">. </p>
<p class="block_"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_007.vue?685fb076